import React from 'react';

import { BaseIconProps } from '.';

export const ArrowPointingToBottom = ({ fill }: BaseIconProps) => (
  <path
    fill={fill}
    d="m225.014,523.17924l234.0966,235.2224l0,-759.92983l166.50089,0l0,752.58506l234.0966,-235.34904l117.74127,118.40266l-436.56875,443.21853l-433.60789,-435.81045l117.74127,-118.33935z"
  />
);
